import React, { render, Component } from 'preact';
import http from './http'

export default class Footer extends Component {




    constructor(props) {
        super(props);
        this.emailRef = React.createRef();
        this.arrivalRef = React.createRef();
        this.departureRef = React.createRef();
        
        this.state = {};
        this.state.buttonText = "Submit";

    }


    submit() {

        var data = { email: this.emailRef.current.value, arrival: this.arrivalRef.current.value, departure: this.departureRef.current.value }


        this.setState({buttonText:"Submitting..."})

        http.post("/submitrequest", data).then((response) => {
            console.log(response)
            this.setState({buttonText:"Done!"})
        })


    }


    componentDidMount() {
        window.$('.datepicker').pickadate();
    }



    render() {
        return (<div id="footer-holder">
            <div id="footer-contact">
                <div class="footer-side">
                    <div id="cant-find-title">Can't Find Your Dates?</div>
                    <div>Let us know when you are coming and we will send you the best price!</div>
                </div>
                <div class="footer-side">
                    <div class="footer-side-child">
                        <input class="request-offer-input" type="text" ref={this.emailRef} id="e-mail-form" placeholder="E-mail" />
                    </div>
                    <div class="footer-side-child">
                        <input class="request-offer-input datepicker" ref={this.arrivalRef} type="text" id="date-form" placeholder="Arrival" />
                    </div>
                    <div class="footer-side-child">
                        <input class="request-offer-input datepicker" ref={this.departureRef} type="text" id="date-form" placeholder="Departure" />
                    </div>
                    <div class="footer-side-child footer-button-holder">
                        <button onClick={() => { this.submit() }} class="footer-button ">{this.state.buttonText}</button>
                    </div>
                </div>
            </div>
            <div id="footer-text"> &copy; 2019 Royal Caribbean Resort, Belize | flashdeals@royalcaribbeanbelize.com </div>
        </div>


        )
    }

}